import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useApp } from "@/store/useApp";
import { staffEntryRoute } from "@/lib/staffWelcome";
import { isStaffRole } from "@/lib/types";
import { toast } from "sonner";

/**
 * Landing route after a successful Google OIDC redirect from the backend.
 * The session cookie is already set by Spring at this point, so we just need
 * to refresh the local auth state and route the user to the right place.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const bootstrapAuth = useApp((s) => s.bootstrapAuth);
  const account = useApp((s) => s.account);
  const authStatus = useApp((s) => s.authStatus);

  useEffect(() => {
    void bootstrapAuth();
  }, [bootstrapAuth]);

  useEffect(() => {
    if (authStatus !== "ready") return;
    if (!account) {
      toast.error("Não foi possível concluir o login com Google");
      navigate("/login", { replace: true });
      return;
    }
    // Conta Google marcada pelo admin para definir senha: a sessão Google provou a identidade, então
    // levamos à criação/troca de senha autenticada antes de seguir.
    if (account.passwordResetRequired) {
      navigate("/redefinir-senha", { replace: true });
      return;
    }
    // Back-office é saudado pelo Nexo (pelo nome) na tela de boas-vindas — sem toast cobrindo o mascote.
    const isBackOffice = isStaffRole(account.role) && account.role !== "ENTREGADOR";
    if (!isBackOffice) toast.success("Bem-vindo");
    navigate(staffEntryRoute(account), { replace: true });
  }, [account, authStatus, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-3 text-sm text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span>Concluindo login com Google...</span>
      </div>
    </div>
  );
}
